import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { shirtTypeSleeveTypes, sleeveTypeFabricTypes } from './compatibility';

export const sleeveTypes = pgTable('sleeve_types', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const sleeveTypesRelations = relations(sleeveTypes, ({ many }) => ({
  shirtTypeSleeveTypes: many(shirtTypeSleeveTypes),
  sleeveTypeFabricTypes: many(sleeveTypeFabricTypes),
}));

export type SleeveType = InferSelectModel<typeof sleeveTypes>;
export type CreateSleeveTypeInput = InferInsertModel<typeof sleeveTypes>;
export type UpdateSleeveTypeInput = Partial<CreateSleeveTypeInput>;
